export default "__VITE_ASSET__CJaV4z8w__"